import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, useLocation } from "react-router-dom";
import { ModalNewCheckList, RouteModal } from "../../components/Modal/Modal";
import HeaderContainer from "../../containers/Header/HeaderContainer";
import RightNav from "../../containers/RightNav/RightNav";
import { SidebarContainer } from "../../containers/Sidebar/SidebarContainer";
import { externalRoute, firstRoute, getEmpty, menuRoutes } from "./routes";

export const AuthRoutes = (props) => {
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("lastPath", location.pathname);
  }, [location.pathname]);

  const user = useSelector((state) => state.app.user || {});
  const company = useSelector((state) => state.app.company || {});

  // Verifica se a rota atual é uma rota autenticada conhecida. Paths como "/"
  // ou "/login" não fazem parte das menuRoutes; quando o usuário logado cai
  // neles, devemos redirecionar para /home em vez de mostrar a tela vazia.
  const isKnownPath = menuRoutes(user, company).some(
    ({ path }) =>
      location.pathname === path ||
      location.pathname.startsWith(`${path}/`)
  );

  return (
    <div className="container-app">
      <SidebarContainer {...props} />
      <div className="body-app">
        <HeaderContainer {...props} />
        <div className="admin-screen-content">
          <div className={"admin-screen-main"}>
            {menuRoutes(user, company).map(({ path, Component }) => (
              <Route key={path} path={path} component={Component} />
            ))}
          </div>
          {menuRoutes(user, company)
            .filter((item) => item.right)
            .map((route, index) => (
              <Route
                key={`route-right-${index}`}
                path={route.path}
                render={(props) => (
                  <RightNav path={route.path}>{route.right(props)}</RightNav>
                )}
              />
            ))}
          {menuRoutes(user, company)
            .filter((item) => item.path === "/modules")
            .map((route, index) => (
              <Route
                key={`route-details-${index}`}
                path={`${route.path}/details/:action/:id`}
                render={(props) => (
                  <RouteModal expanded={true} {...route}>
                    {route.details({ ...props, parentPath: route.path })}
                  </RouteModal>
                )}
              />
            ))}
          {menuRoutes(user, company)
            .filter((item) => item.details)
            .map((route, index) => (
              <Route
                key={`route-details-${index}`}
                path={`${route.path}/details/:id`}
                render={(props) => (
                  <RouteModal expanded={true} {...route}>
                    {route.details({ ...props, parentPath: route.path })}
                  </RouteModal>
                )}
              />
            ))}
          <Route
            path="*"
            render={() => (isKnownPath ? null : <Redirect to="/home" />)}
          />
        </div>
      </div>
      {/* <Redirect to="/dashboard" /> */}
    </div>
  );
};

export const FirstRoute = (props) => {
  return (
    <>
      {firstRoute.map(({ path, Component }) => (
        <Route
          key={path}
          path={path}
          component={() => <Component {...props} />}
        />
      ))}
      <Redirect to="/change-password" />
    </>
  );
};

export const ExternalRoute = ( props) => {
  return (
    <>
      {externalRoute.map(({ path, Component }) => (
        <Route
          key={path}
          path={path}
          component={() => <Component {...props} />}
        />
      ))}
    </>
  );
}